import { API_URL } from '../api'

let installed = false
const reported = new Set<string>()

function report(message: string, stack: string | null, component: string) {
  const key = `${component}|${message}|${stack || ''}`.slice(0, 2000)
  if (!message || reported.has(key) || reported.size >= 100) return
  reported.add(key)
  void fetch(`${API_URL}/heal/client-errors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message, stack, component, failing_url: `${window.location.origin}${window.location.pathname}` }),
    keepalive: true,
  }).catch(() => undefined)
}

export function installHealErrorCapture(): () => void {
  if (installed) return () => undefined
  installed = true
  const onError = (event: ErrorEvent) => {
    report(event.message || 'Unhandled browser error', event.error instanceof Error ? event.error.stack || null : null, 'window.error')
  }
  const onRejection = (event: PromiseRejectionEvent) => {
    const reason = event.reason
    report(reason instanceof Error ? reason.message : String(reason || 'Unhandled promise rejection'),
      reason instanceof Error ? reason.stack || null : null, 'unhandledrejection')
  }
  window.addEventListener('error', onError)
  window.addEventListener('unhandledrejection', onRejection)
  return () => {
    window.removeEventListener('error', onError)
    window.removeEventListener('unhandledrejection', onRejection)
    installed = false
    reported.clear()
  }
}
